module.exports = __webpack_public_path__ + "img/Snipaste_2023-07-21_17-59-29.50b93db5.png";